<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>

        <template v-if="breakpoint != 'md'">
          <!-- STARRED PAGES - FIRST 10 -->
          <ul class="vx-navbar__starred-pages">
            <draggable
              v-model="starredPagesLimited"
              :group="{ name: 'pinList' }"
              class="flex cursor-move"
            >
              <li
                class="starred-page"
                v-for="page in starredPagesLimited"
                :key="page.url"
              >
                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                  <feather-icon
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    :icon="page.labelIcon"
                    @click="$router.push(page.url)"
                  ></feather-icon>
                </vx-tooltip>
              </li>
            </draggable>
          </ul>
        </template>

        <vs-spacer></vs-spacer>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ user_displayName }}</p>
          </div>
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
          >
            <div class="con-img ml-3">
              <img
                v-if="activeUserImg.startsWith('http')"
                key="onlineImg"
                :src="activeUserImg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <img
                v-else
                key="localImg"
                src="data:image/png;base64,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"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <!--li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/pages/profile')"
                >
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Profile</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/email')"
                >
                  <feather-icon icon="MailIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Inbox</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/todo')"
                >
                  <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Tasks</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/chat')"
                >
                  <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Chat</span>
                </li>
                <vs-divider class="m-1"></vs-divider-->
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/Login')"
                >
                  <feather-icon
                    icon="LogOutIcon"
                    svgClasses="w-4 h-4"
                  ></feather-icon>
                  <span class="ml-2">Logout</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import jwt from "jsonwebtoken";
import utilsList from "./../../utils/list";
export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      decoded: utilsList.buscaToken(),
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      unreadNotifications: [
        {
          index: 0,
          title: "New Message",
          msg: "Are your going to meet me tonight?",
          icon: "MessageSquareIcon",
          time: "Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)",
          category: "primary",
        },
        {
          index: 1,
          title: "New Order Recieved",
          msg: "You got new order of goods.",
          icon: "PackageIcon",
          time: "Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)",
          category: "success",
        },
        {
          index: 2,
          title: "Server Limit Reached!",
          msg: "Server have 99% CPU usage.",
          icon: "AlertOctagonIcon",
          time: "Thu Jan 31 2019 07:45:23 GMT+0000 (GMT)",
          category: "danger",
        },
        {
          index: 3,
          title: "New Mail From Peter",
          msg: "Cake sesame snaps cupcake",
          icon: "MailIcon",
          time: "Fri Feb 01 2019 07:45:23 GMT+0000 (GMT)",
          category: "primary",
        },
        {
          index: 4,
          title: "Bruce's Party",
          msg: "Chocolate cake oat cake tiramisu",
          icon: "CalendarIcon",
          time: "Fri Feb 02 2019 07:45:23 GMT+0000 (GMT)",
          category: "warning",
        },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },

    // PROFILE
    user_displayName() {
      return this.decoded.nome;
      // return JSON.parse(localStorage.getItem('userInfo')).displayName
    },
    activeUserImg() {
      if (localStorage.getItem("userInfo")) {
        return (
          JSON.parse(localStorage.getItem("userInfo")).photoURL ||
          this.$store.state.AppActiveUser.img
        );
      } else {
        return "avatar-s-11.png";
      }
    },
  },
  mounted() {
    this.preencheDados();
  },
  methods: {
    preencheDados() {
      const token = localStorage.getItem("user-token");
      this.decoded = jwt.decode(token);
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `${seconds} sec ago` : "just now");
      }

      return "Just Now";
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
  },
};
</script>
<style lang="scss" scoped>
.link-help {
  color: #333 !important;
  span.text {
    margin: 2px 0 0 5px;
    float: right;
  }
}
.linkmenu {
  color: #666 !important;
  :hover {
    color: #fff !important;
  }
}
</style>
